(function () {
    'use strict';

    angular
        .module('app')
        .directive('pageSearch', pageSearch);

    pageSearch.$inject = ['$window', 'searchService'];

    function pageSearch($window, searchService) {
        var directive = {
            bindToController: true,
            controller: ['$scope', '$location', '$timeout', controller],
            controllerAs: '$pageSearch',
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope) {
            $("button.sort_btn").click(function () {
                $("#filter-by").removeClass("expanded");
                $("#sort-by").removeClass("is-invisible");
                $("#filter-by").toggleClass("is-invisible");
                $("#sort-by").toggleClass("expanded");
            });

            $("button.filter_btn").click(function () {
                $("#sort-by").removeClass("expanded");
                $("#filter-by").removeClass("is-invisible");
                $("#sort-by").toggleClass("is-invisible");
                $("#filter-by").toggleClass("expanded");
            });

            $("#searchBox").autocomplete({
                highlight: true,
                appendTo: '#main-search-autocomplete',
                source: function (request, response) {
                    $.ajax({
                        url: "/api/search/autocomplete",
                        dataType: "json",
                        type: 'Get',
                        data: {
                            term: request.term,
                            size: window.searchAutocompSize
                        },
                        success: function (data) {

                            response($.map(data.Data,
                                function (item) {
                                    return {
                                        label: item,
                                        value: item
                                    };
                                }));
                        }
                    });
                },
                select: function (event, ui) {
                    $(this).val(ui.item.value);
                    $(this).trigger('input'); // Use for Chrome/Firefox/Edge
                    $(this).trigger('change');
                    $(this).closest('form').submit();
                },
                minLength: 2
            });

            (function () {
                var d = document,
                    accordionToggles = d.querySelectorAll('.js-accordionTrigger'),
                    touchSupported = ('ontouchstart' in window),
                    pointerSupported = ('pointerdown' in window);

                var skipClickDelay = function (e) {
                    e.preventDefault();
                    e.target.click();
                };

                var setAriaAttr = function (el, ariaType, newProperty) {
                    el.setAttribute(ariaType, newProperty);
                };
                var setAccordionAria = function (el1, el2, expanded) {
                    switch (expanded) {
                    case "true":
                        setAriaAttr(el1, 'aria-expanded', 'true');
                        setAriaAttr(el2, 'aria-hidden', 'false');
                        break;
                    case "false":
                        setAriaAttr(el1, 'aria-expanded', 'false');
                        setAriaAttr(el2, 'aria-hidden', 'true');
                        break;
                    default:
                        break;
                    }
                };
                //function
                var switchAccordion = function (e) {
                    console.log("triggered");
                    e.preventDefault();
                    var thisAnswer = e.target.parentNode.nextElementSibling;
                    var thisQuestion = e.target;
                    if (thisAnswer.classList.contains('is-collapsed')) {
                        setAccordionAria(thisQuestion, thisAnswer, 'true');
                    } else {
                        setAccordionAria(thisQuestion, thisAnswer, 'false');
                    }
                    thisQuestion.classList.toggle('is-collapsed');
                    thisQuestion.classList.toggle('is-expanded');
                    thisAnswer.classList.toggle('is-collapsed');
                    thisAnswer.classList.toggle('is-expanded');

                    thisAnswer.classList.toggle('animateIn');
                };
                for (var i = 0, len = accordionToggles.length; i < len; i++) {
                    if (touchSupported) {
                        accordionToggles[i].addEventListener('touchstart', skipClickDelay, false);
                    }
                    if (pointerSupported) {
                        accordionToggles[i].addEventListener('pointerdown', skipClickDelay, false);
                    }
                    accordionToggles[i].addEventListener('click', switchAccordion, false);
                }
            })();

            jQuery(document).ready(function (e) {
                function t(t) {
                    e(t).bind("click", function (t) {
                        t.preventDefault();
                        e(this).parent().fadeOut();
                    });
                }
                e(".dropdown-toggle").click(function () {
                    var t = e(this).parents(".button-dropdown").children(".dropdown-m").is(":hidden");
                    e(".button-dropdown .dropdown-m").hide();
                    e(".button-dropdown .dropdown-toggle").removeClass("active");
                    if (t) {
                        e(this).parents(".button-dropdown").children(".dropdown-m").toggle().parents(".button-dropdown").children(".dropdown-toggle").addClass("active")
                    }
                });
                e(document).bind("click", function (t) {
                    var n = e(t.target);
                    if (!n.parents().hasClass("button-dropdown")) e(".button-dropdown .dropdown-m").hide();
                });
                e(document).bind("click", function (t) {
                    var n = e(t.target);
                    if (!n.parents().hasClass("button-dropdown")) e(".button-dropdown .dropdown-toggle").removeClass("active");
                });
                e(document).bind("click", function (t) {
                    var n = e(t.target);
                    if (!n.parents().hasClass("searchFilters")) e(".ftWrap").hide();
                });


                //Search Filters - mb
                $(".searchFilters").on("click", ".filtersTool", function (e) {

                    $('.filtersTool').not(this).closest(".filtersBlock").find(".ftWrap").each(function () {
                        $(this).slideUp('fast');
                    });

                    $(this).closest(".filtersBlock").find(".ftWrap").slideToggle('fast');
                });

               


            });


            $('a.dropdown-toggle').on("click", function (e) {
                e.preventDefault();
                var id = $(this).attr('data-id');
                $(".search-items").each(function () {
                    if ($(this).attr('id') === id) {
                        if ($(this).hasClass('hide')) {
                            $(this).removeClass('hide');
                        } else {
                            $(this).addClass('hide');
                        }
                    } else {
                        $(this).addClass('hide');
                    }
                });
            });

            $('div.apply-filter').on("click", function (e) {
                e.preventDefault();
                $(".search-items").each(function () {
                    $(this).addClass('hide');
                });
            });

            $('button.apply-filter-mobile').on("click", function (e) {
                $("#filter-by").removeClass('expanded');
            });

            $(document).click(function (e) {
                var isFilterDropdown = $(e.target).closest('.search-items').length;
                var isFilterButton = $(e.target).closest('.filter-dropdown').length;
                var mobileFDropDown = $(e.target).closest('#filter-by').length;
                var mobileFButton = $(e.target).closest('.filter_btn').length;
                var mobileSortDropDown = $(e.target).closest('#sort-by').length;
                var mobileSortButton = $(e.target).closest('.sort_btn').length;

                if (!isFilterDropdown && !isFilterButton) {
                    $(".search-items").each(function(index) {
                        if (!$(this).hasClass("hide"))
                        {
                            $(this).addClass("hide");
                        }
                    });
                }

                if ((!mobileFDropDown && !mobileFButton)) {
                    if ($("#filter-by").hasClass("expanded")) {
                        $("#filter-by").removeClass("expanded");
                    }
                }

                if (!mobileSortButton && !mobileSortDropDown) {
                    if ($("#sort-by").hasClass("expanded")) {
                        $("#sort-by").removeClass("expanded");
                    }
                }
            });

            
        }

        function controller($scope, $location, $timeout) {
            var $ctrl = this;
            $ctrl.pageload = true;
            $ctrl.STORAGEKEY = 'acep-search-meta';

            $ctrl.text = "";
            $ctrl.lastSearch = "";
            $ctrl.resultsPagesCount = 1;
            $ctrl.results = [];
            $ctrl.resultsCount = 0;
            //$ctrl.shownResults = [];
            $ctrl.skip = 0;
            $ctrl.page = 1;
            $ctrl.pageSize = 1;
            $ctrl.pageStart = 0;
            $ctrl.pageEnd = 0;
            $ctrl.sort = "relevance";
            $ctrl.relOrder = "desc";
            $ctrl.dateOrder = "desc";
            $ctrl.sources = [];
            $ctrl.sourcesHits = 0;
            $ctrl.selectedSources = [];
            $ctrl.types = [];
            $ctrl.typesHits = 0;
            $ctrl.selectedTypes = [];
            $ctrl.ages = [{ Name: 'The Last Day', Count: 0 }, { Name: 'The Last Week', Count: 0 }, { Name: 'The Last Month', Count: 0 }, { Name: 'The Last Year', Count: 0 }];
           
            $ctrl.contentTypeCategories = [];
            $ctrl.contentTypeCategoriesHits = 0;
            $ctrl.selectedContentTypeCategories = [];
            $ctrl.categories = [];
            $ctrl.selectedAge = "";
            $ctrl.resultsLimit = 0;
            $ctrl.runSearch = true;
            $ctrl.activeTypes = [];
            $ctrl.activeSources = [];
            $ctrl.activeContentTypeCategories = [];
            $ctrl.activeAge = "";
            $ctrl.paginationShown = false;
            $ctrl.resetPagination = false;
            $ctrl.searchResultSiteName = "other";
            $ctrl.microsite = "";
            $ctrl.category = "";

            $ctrl.loadingImage = $('.loading-overlay');
            $ctrl.pagination = $('#pagination');
            var defaultOptions = {
                visiblePages: 3,
                next: 'Next',
                prev: 'Prev',
                onPageClick: function (event, page) {
                    //set current page in storage
                    //$ctrl.SaveSearchMetaToStorage(page);
                    $timeout($ctrl.changePage(page), 1000);
                }
            }

            $ctrl.pagination.twbsPagination(
                $.extend({},
                defaultOptions, {
                totalPages: $ctrl.resultsPagesCount
                }));

            var metaSite = $("meta[name=siteName]").attr("content");

            if (metaSite) {
                $ctrl.selectedSites.push(metaSite);
            }


            var searchParams = [], hash;
            var sourceQS = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for (var i = 0; i < sourceQS.length; i++) {
                hash = sourceQS[i].split('=');
                var key = hash[0].toLowerCase();
                searchParams.push(key);
                searchParams[key] = decodeURIComponent(hash[1]);
            }

            $ctrl.init = function (pageSize, includeAllResults) {
                //init
               $ctrl.GetSearchMetaFromStorage();
                $ctrl.skip = ($ctrl.page - 1) * pageSize;

                if ($ctrl.text !== "") {
                    $ctrl.resetPagination = true;
                    $ctrl.search(null, pageSize);
                }

                if ($ctrl.selectedSources.length > 0 && includeAllResults !== null) {
                    $ctrl.includeAllResults = (includeAllResults.toLowerCase() === "true");
                }

               
            }

            $ctrl.search = function (e, pageSize) {
                if (e) {
                    e.preventDefault();

                    //START UPDATE DATA LAYER SCRIPTS MB
                    var obj = {
                        'SearchText': $ctrl.text,
                        'SearchPage': document.referrer.split('?')[0]
                    };
                    updateDatalayer_SearchPage(obj, 'SearchQuery');
                //END DATA LAYER SCRIPTS

                    //reset page in localstorage
                    $ctrl.RemoveSearchMetaFromStorage();

                    if ($ctrl.text !== "") {
                        var oldQueryIndex = $window.location.href.toLowerCase().indexOf('searchtext=');
                        var url = $window.location.href;

                        if (oldQueryIndex !== -1) {
                            url = url.slice(0, oldQueryIndex);
                        }

                        $ctrl.runSearch = false;

                        $window.location.href = url + (url.indexOf('?') === -1 ? '?' : '') +  "searchtext=" + encodeURIComponent($ctrl.text);
                    }
                }

                if ($ctrl.runSearch === true) {
                    $('#search-Results').hide();
                    $ctrl.loadingImage.show();

                    if ($ctrl.text === "") {
                        $ctrl.page = 1;
                    }
                    $ctrl.pageSize = pageSize;
                    $ctrl.results = [];

                    $ctrl.setActiveFilters();

                    var sortOrder = "";

                    if ($ctrl.sort === "relevance") {
                        sortOrder = $ctrl.relOrder;
                    } else if ($ctrl.sort === "date") {
                        sortOrder = $ctrl.dateOrder;
                    }

                    if ($ctrl.text !== "") {
                        searchService.getResults($ctrl.text,
                                $ctrl.selectedTypes,
                                $ctrl.selectedSources,
                                $ctrl.selectedContentTypeCategories,
                                $ctrl.selectedAge,
                                $ctrl.skip,
                                pageSize,
                                $ctrl.sort,
                                sortOrder,
                            $ctrl.microsite,
                            $ctrl.category)
                            .then(function(results) {
                                $ctrl.resultsCount = results.TotalResults;

                                results.Results.forEach(function(result) {
                                    $ctrl.results.push(result);
                                });

                                //$ctrl.shownResults = $ctrl.results.slice(0, pageSize);

                                $ctrl.types.forEach(function(filter) {
                                    filter.Count = 0;
                                });
                                results.TypeFilters.forEach(function(filter) {
                                    var index = $ctrl.types.findIndex(function(e) {
                                        return e.Name === filter.Name;
                                    });

                                    if (index !== -1) {
                                        $ctrl.types.splice(index, 1, filter);
                                    } else {
                                        $ctrl.types.push(filter);
                                    }
                                });
                                //remove all 0's
                                $ctrl.types = $ctrl.types.filter(a => a.Count > 0);

                                $ctrl.typesHits = $ctrl.sum($ctrl.types, 'Count');




                                $ctrl.contentTypeCategories.forEach(function (filter) {
                                    filter.Count = 0;
                                });
                                results.ContentTypeCategoriesFilters.forEach(function (filter) {
                                    var index = $ctrl.contentTypeCategories.findIndex(function (e) {
                                        return e.Name === filter.Name;
                                    });

                                    if (index !== -1) {
                                        $ctrl.contentTypeCategories.splice(index, 1, filter);
                                    } else {
                                        $ctrl.contentTypeCategories.push(filter);
                                    }
                                });
                                //remove all 0's
                                $ctrl.contentTypeCategories = $ctrl.contentTypeCategories.filter(a => a.Count > 0);
                                $ctrl.contentTypeCategoriesHits = $ctrl.sum($ctrl.contentTypeCategories, 'Count');









                                $ctrl.sources.forEach(function(filter) {
                                    filter.Count = 0;
                                });
                                results.SourceFilters.forEach(function(filter) {
                                    var index = $ctrl.sources.findIndex(function(e) {
                                        return e.Name === filter.Name;
                                    });

                                    if (index !== -1) {
                                        $ctrl.sources.splice(index, 1, filter);
                                    } else {
                                        $ctrl.sources.push(filter);
                                    }
                                });
                                $ctrl.sourcesHits = $ctrl.sum($ctrl.sources, 'Count');

                                if (results.AgeCounts != null) {
                                    results.AgeCounts.forEach(function (age) {
                                        var index = $ctrl.ages.findIndex(function (e) {
                                            return e.Name === age.Name;
                                        });

                                        if (index !== -1) {
                                            $ctrl.ages[index].Count = age.Count;
                                        }
                                    });
                                }

                                $ctrl.lastSearch = $ctrl.text;
                                if ($ctrl.text.startsWith('"') && $ctrl.text.endsWith('"')) {
                                    $ctrl.lastSearch = $ctrl.text.substring(1, $ctrl.text.length - 1);
                                }

                                if ($ctrl.resetPagination) {
                                    $ctrl.updatePagination();
                                    $ctrl.resetPagination = false;
                                    $ctrl.paginationShown = true;
                                }

                                var pageEnd = $ctrl.skip + $ctrl.pageSize;

                                if (pageEnd > $ctrl.resultsCount) {
                                    pageEnd = $ctrl.resultsCount;
                                }

                                $ctrl.pageStart = $ctrl.skip + 1;
                                $ctrl.pageEnd = pageEnd;

                                $ctrl.loadingImage.hide();
                                $('#search-Results').show();
                            });
                    } else {


                        var pageEnd = $ctrl.skip + $ctrl.pageSize;

                        if (pageEnd > $ctrl.resultsCount) {
                            pageEnd = $ctrl.resultsCount;
                        }

                        $ctrl.pageStart = $ctrl.skip + 1;
                        $ctrl.pageEnd = pageEnd;
                        $ctrl.lastSearch = "";
                        $ctrl.resultsCount = 0;
                        $ctrl.updatePagination();
                        $ctrl.resetFilters($ctrl.pageSize);

                        $ctrl.loadingImage.hide();
                        $('#search-Results').show();
                    }
                }

                $(".ftWrap").hide();
            }
            //set microsite
            if (searchParams["microsite"]) {
                $ctrl.microsite = searchParams["microsite"].toUpperCase();
            }
            //set category
            if (searchParams["category"]) {
                $ctrl.category = searchParams["category"];
            }

            if (searchParams["searchtext"]) {
                var searchText = searchParams["searchtext"].replace(/&#39;/g, "\'").replace(/&quot;/g, "\"").replace(/&amp;/g, "&");
                var index = searchText.length;

                if (searchText.indexOf('#') !== -1) {
                    index = searchText.indexOf('#');
                }

                $ctrl.text = searchText.substr(0, index);
            }

            $ctrl.getSiteName = function (siteName) {
                var _site = "other";
                if (siteName === 'ACEP') {
                    _site = "acep";
                }
                else if (siteName === 'Newsroom') {
                    _site = "newsroom";
                }
                else if (siteName === 'ACEP Now') {
                    _site = "acepnow";
                }
                else if (siteName === 'Emergency Physicians') {
                    _site = "emp";
                }
                else if (siteName === 'ACEP Advocacy') {
                    _site = "advocacy";
                }

                //$ctrl.searchResultSiteName = _site;

                return _site;

            }

            $ctrl.changePage = function(page) {
                $ctrl.skip = (page - 1) * $ctrl.pageSize;
                $ctrl.page = page;
                //START UPDATE DATA LAYER SCRIPTS MB
                var obj = {
                    'SearchText': $ctrl.text,
                    'PageIndex': page
                };
                if ($ctrl.pageload == false) {
                    updateDatalayer_SearchPage(obj, 'SearchPageChange');
                }
                //END DATA LAYER SCRIPTS

                if ($ctrl.paginationShown) {
                    $ctrl.search(null, $ctrl.pageSize);
                }

                $ctrl.pageload = false;
            }

            $ctrl.updatePagination = function () {
                if ($ctrl.resultsCount) {
                    $ctrl.resultsPagesCount = Math.ceil($ctrl.resultsCount / $ctrl.pageSize);
                } else {
                    $ctrl.resultsPagesCount = 1;
                }

                $ctrl.pagination.twbsPagination('destroy');

                $ctrl.pagination.twbsPagination(
                    $.extend({},
                    defaultOptions, {
                        totalPages: $ctrl.resultsPagesCount,
                        startPage: $ctrl.page
                    }));

                if ($ctrl.text === '') {
                    $ctrl.skip = 0;
                }
            }

            //$ctrl.sortResults = function () {
            //    if ($ctrl.sort == "relevance") {

            //    }
            //}

            $ctrl.sortByRelevance = function (pageSize) {
                if ($ctrl.sort === "relevance") {
                    if ($ctrl.relOrder === "asc") {
                        $ctrl.relOrder = "desc";
                    } else if ($ctrl.relOrder === "desc") {
                        $ctrl.relOrder = "asc";
                    }
                } else {
                    $ctrl.sort = "relevance";
                }

                $ctrl.search(null, pageSize);
            }

            $ctrl.sortByRelevanceMobile = function (pageSize) {
                $ctrl.relOrder = "desc";
                $ctrl.sort = "relevance";
                $("#sort-by").removeClass("expanded");

                $ctrl.search(null, pageSize);
            }

            $ctrl.sortByDate = function (pageSize) {

                if ($ctrl.sort === "date") {
                    if ($ctrl.dateOrder === "asc") {
                        $ctrl.dateOrder = "desc";
                    } else if ($ctrl.dateOrder === "desc") {
                        $ctrl.dateOrder = "asc";
                    }
                } else {
                    $ctrl.sort = "date";
                }

                $ctrl.search(null, pageSize);
            }

            $ctrl.sortByDateDesc = function (pageSize) {
                $ctrl.dateOrder = "desc";
                $ctrl.sort = "date";
                $("#sort-by").removeClass("expanded");

                $ctrl.search(null, pageSize);
            }

            $ctrl.sortByDateAsc = function (pageSize) {
                $ctrl.dateOrder = "asc";
                $ctrl.sort = "date";
                $("#sort-by").removeClass("expanded");

                $ctrl.search(null, pageSize);
            }

            $ctrl.toggleFilter = function (item, collection) {
                var index = collection.indexOf(item);

                if (index > -1) {
                    collection.splice(index, 1);
                } else {
                    collection.push(item);
                }

                //$ctrl.resetPagination = true;
                //$ctrl.page = 1;
                //$ctrl.skip = 0;
            }

            $ctrl.setAge = function (age) {
                $ctrl.selectedAge = age;
                $ctrl.resetPagination = true;
            }

            $ctrl.resetPaginationAndSearch = function (key, pageSize) {
                
                $ctrl.resetPagination = true;
                $ctrl.pageload = true;
                $ctrl.page = 1;
                $ctrl.skip = 0;             

                //DATA LAYER SCRIPTS
                var _selectedFilters = [];
                var obj = {
                    'event': 'searchFilterOrSortClick',
                    'search_FilterKey': key,
                    'search_Text': $ctrl.text
                };
                switch (key) {
                    case 'categories':
                        _selectedFilters = $ctrl.selectedContentTypeCategories;                       
                        break;
                    case 'contentTypes':
                        _selectedFilters = $ctrl.selectedTypes;
                        break;
                    case 'sort':
                        _selectedFilters = $ctrl.selectedTypes;
                        obj['sort'] = $ctrl.sort;
                        break;

                    default:
                        break;
                }

                for (var i = 0; i < _selectedFilters.length; i++) {
                    var k = 'filter_' + _selectedFilters[i].replace(/\s+/g, '');
                    obj[k] = true;
                }              

               
                updateDatalayer_SearchPage(obj, 'SearchFiltersAndSort');
                

                if ($ctrl.text !== "") {
                    $ctrl.search(null, pageSize);
                }
            }

            $ctrl.resetFilters = function(pageSize) {
                $ctrl.activeTypes = [];
                $ctrl.activeSources = [];
                $ctrl.activeContentTypeCategories = [];
                $ctrl.activeAge = "";
                $ctrl.selectedTypes = [];
                $ctrl.selectedSources = [];
                $ctrl.selectedContentTypeCategories = [];
                $ctrl.selectedAge = "";
                $ctrl.resetPagination = true;
                $ctrl.page = 1;
                $ctrl.skip = 0;
                $ctrl.pageload = true;

                if ($ctrl.text !== "") {
                    $ctrl.search(null, pageSize);
                }
            }

            $ctrl.setActiveFilters = function () {
                $ctrl.activeTypes = [];
                $ctrl.activeSources = [];
                $ctrl.activeContentTypeCategories = [];

                $ctrl.selectedTypes.forEach(function (type) {
                    $ctrl.activeTypes.push(type);
                });
                $ctrl.selectedSources.forEach(function (source) {
                    $ctrl.activeSources.push(source);
                });
                $ctrl.selectedContentTypeCategories.forEach(function (cat) {
                    $ctrl.activeContentTypeCategories.push(cat);
                });
                $ctrl.activeAge = $ctrl.selectedAge;
            }

            $ctrl.sum = function (collection, prop) {
                return collection.reduce(function (a, b) {
                    return a + b[prop];
                }, 0);
            }

            $ctrl.trackClick = function (ev, searchResult, ind) {
                //ev.preventDefault();

                //$(ev.currentTarget).closest('.single-search')
                let rank = (($ctrl.pageSize) * ($ctrl.page - 1))  + (ind + 1);
                searchResult.Rank = rank;
                searchResult.SearchText = $ctrl.text;
                updateDatalayer_SearchPage(searchResult, 'SearchResultClick');

                //Save the page metadata to storage
                $ctrl.SaveSearchMetaToStorage($ctrl.page, $ctrl.selectedTypes, $ctrl.selectedContentTypeCategories, $ctrl.sort)


                return;
                var href = searchResult.Url;
                var redirectBase = href.split("?")[0];
                var queryStr =  queryString(href);

                var t_id = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_id'; }), 1);
                var t_q = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_q'; }), 1);
                var t_hit_id = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_hit.id'; }), 1);
                var t_hit_pos = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_hit.pos'; }), 1);
                var t_ip = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_ip'; }), 1); // not used, but needs to be removed
                var t_tags = queryStr.splice(queryStr.findIndex(function (x) { return x.id === '_t_tags'; }), 1); // not used, but needs to be removed

                //create redirect url
                if (queryStr.length > 0) {
                    redirectBase = redirectBase + "?";
                    var params = [];
                    queryStr.forEach(function (item) {
                        var queryParam = item.id + "=" + item.value;
                        params.push(queryParam);
                    });
                    redirectBase = redirectBase + params.join('&');
                }

                //track click
                if (t_id[0].value && t_q[0].value && t_hit_id[0].value && t_hit_pos[0].value) {
                    searchService.trackClick(t_id[0].value, t_q[0].value, t_hit_id[0].value, t_hit_pos[0].value)
                        .then(function (response) {
                                console.log(response);
                            },
                            function () {
                                console.log('an error occured registering click event');
                            });
                }

                //DATA LAYER VARIABLES
                updateDatalayer(searchResult);
                


                $window.location.href = redirectBase;
            }

            $ctrl.RemoveSearchMetaFromStorage = function () {
                sessionStorage.removeItem($ctrl.STORAGEKEY)
            }

            $ctrl.SaveSearchMetaToStorage = function (currentPage, contentTypes, contentTypeCategories, sort) {
                var timeout = new Date();
                timeout.setHours(timeout.getHours() + 0.5); //half hour from now

                var object = { page: currentPage, contentTypes: contentTypes, contentTypeCategories: contentTypeCategories, sort: sort, searchtext: $ctrl.text, timeout: timeout };
                sessionStorage.setItem($ctrl.STORAGEKEY, JSON.stringify(object));
            }

            $ctrl.GetSearchMetaFromStorage = function () {
                var searchtxt = '';
                var lsdata = sessionStorage.getItem($ctrl.STORAGEKEY);
                var _page = 1;
                var _sort = 'relevance';
                var _selectedTypes = [];
                var _selectedContentTypeCategories = [];
                if (lsdata !== null) {
                    var object = JSON.parse(lsdata);
                    var _searchtext = object.searchtext;                    
                    if (_searchtext === $ctrl.text) {
                        _page = object.page;
                        _sort = object.sort;
                        _selectedTypes = object.contentTypes;
                        _selectedContentTypeCategories = object.contentTypeCategories;

                    }
                }
                $ctrl.page = _page;
                $ctrl.sort = _sort;
                $ctrl.selectedTypes = _selectedTypes;
                $ctrl.selectedContentTypeCategories = _selectedContentTypeCategories;
            }



            function getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            }

            function queryString(href) {
                var vars = [], hash;
                var hashes = href.slice(href.indexOf('?') + 1).split('&');
                for (var i = 0; i < hashes.length; i++) {
                    hash = hashes[i].split('=');
                    vars.push({ id: hash[0], value: hash[1]});                    
                }
                return vars;
            }

            function byRelevanceAsc(a, b) {
                if (a.Relevance > b.Relevance) {
                    return 1;
                }
                if (a.Relevance < b.Relevance) {
                    return -1;
                }

                return 0;
            }

            function byRelevanceDesc(a, b) {
                if (a.Relevance < b.Relevance) {
                    return 1;
                }
                if (a.Relevance > b.Relevance) {
                    return -1;
                }

                return 0;
            }

            function byDateAsc(a, b) {
                if (a.Date > b.Date) {
                    return 1;
                }
                if (a.Date < b.Date) {
                    return -1;
                }
                return 0;
            }

            function byDateDesc(a, b) {
                if (a.Date < b.Date) {
                    return 1;
                }
                if (a.Date > b.Date) {
                    return -1;
                }
                return 0;
            }

           

        }
    }
})();



//////////////////
// WEBPACK FOOTER
// ./static/common/js/directives/_searchPage.js
// module id = 13
// module chunks = 0